import ArticleLayout from "@/components/feature/ArticleLayout";
import { newArticles } from "@/mocks/articles";

export default function VerificarLinksHoobuy() {
  return <ArticleLayout article={newArticles[1]} />;
}